import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BackendService {

  constructor(private _http: HttpClient  ) { }


  getSelectedView() {
    return  localStorage.getItem('selected_view') ? localStorage.getItem('selected_view') : '';
  }
  getToken() {
    const token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
    console.log(token);
    return token;
  }

  // --------------------- SET ------------------------- //
    setUser(formData) {
      console.log('ADD user -----backend.service.ts ----PASO POR: setUser');
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json'}) };
      return this._http.post('https://bckend.miape.me/signup', formData, httpOptions);
    }

    setMMSE(formData) {
      console.log('ADD minimental -----backend.service.ts ----PASO POR: setMMSE');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/minimental', formData, httpOptions);
    }

    setBDS(formData) {
      console.log('ADD blessed -----backend.service.ts ----PASO POR: setBDS');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/blessed', formData, httpOptions);
    }

    setUCLA(formData) {
      console.log('ADD ucla -----backend.service.ts ----PASO POR: setUCLA');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/ucla', formData, httpOptions);
    }

    setPANAS(formData) {
      console.log('ADD panas -----backend.service.ts ----PASO POR: setPANAS');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/panas', formData, httpOptions);
    }

    setWHOQOL(formData) {
      console.log('ADD whoqol -----backend.service.ts ----PASO POR: setWHOQOL');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/whoqol', formData, httpOptions);
    }

    setGDS(formData) {
      console.log('ADD gds -----backend.service.ts ----PASO POR: setGDS');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/gds', formData, httpOptions);
    }

    setESCALASOCIAL(formData) {
      console.log('ADD escalasocial -----backend.service.ts ----PASO POR: setESCALASOCIAL');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/escalasocial', formData, httpOptions);
    }

    setESC(formData) {
      console.log('ADD esc -----backend.service.ts ----PASO POR: setESC');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/esc', formData, httpOptions);
    }

    setNACI(formData) {
      console.log('ADD naci -----backend.service.ts ----PASO POR: setNACI');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/naci', formData, httpOptions);
    }

    setPNACI(formData) {
      console.log('ADD pnaci -----backend.service.ts ----PASO POR: setPNACI');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/pnaci', formData, httpOptions);
    }


    setEARVI(formData) {
      console.log('ADD earvi -----backend.service.ts ----PASO POR: setEARVI');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/earvi', formData, httpOptions);
    }

    setInstitution(formData) {
      console.log('ADD institucion -----backend.service.ts ----PASO POR: setInstitution');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/instituciones', formData, httpOptions);
    }

    setProject(formData) {
      console.log('ADD project -----backend.service.ts ----PASO POR: setProject');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/proyectos', formData, httpOptions);
    }

    setInstitutionsPerProject(formData, id_project) {
      console.log('ADD project institutions -----backend.service.ts ----PASO POR: setInstitutionsPerProject');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/proyectos/' + id_project + '/institutions', formData, httpOptions);
    }

    setPlace(formData) {
      console.log('ADD place -----backend.service.ts ----PASO POR: setPlace');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/lugares', formData, httpOptions);
    }

    setCiudadano(formData) {
      console.log('UPDATE ciudadano -----backend.service.ts ----PASO POR: updateCidudadno');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      console.log(formData);
      return this._http.post('https://bckend.miape.me/layout/ciudadano', formData, httpOptions);
    }

    setForm1(formData) {
      console.log('UPDATE form1 -----backend.service.ts ----PASO POR: setForm1');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/forms', formData, httpOptions);
    }

    setForm2(formData) {
      console.log('ADD form2 -----backend.service.ts ----PASO POR: setForm2');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/form2', formData, httpOptions);
    }
    setForm3(formData) {
      console.log('ADD form3 -----backend.service.ts ----PASO POR: setForm3');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      console.log('ENCS-SECCIÓN 3 -----backend.service.ts ----PASO POR: setForm3');
      return this._http.post('https://bckend.miape.me/layout/form3', formData, httpOptions);
    }

    setForm4(formData) {
      console.log('ADD form4 -----backend.service.ts ----PASO POR: setForm4');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/form4', formData, httpOptions);
    }



    // ---------------------- GET --------------------- //
    getUser() {
      console.log('GET user -----backend.service.ts ----PASO POR: gettUser');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/blank-page', httpOptions);
    }

    getInstitutionalUser() {
      console.log('GET user -----backend.service.ts ----PASO POR: gettUser');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/institutional-user', httpOptions);
    }

    getResearchers() {
      console.log('GET user -----backend.service.ts ----PASO POR: gettUser');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/researchers', httpOptions);
    }

    getCollaborators() {
      console.log('GET user -----backend.service.ts ----PASO POR: gettUser');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/collaborators', httpOptions);
    }

    getPlaces() {
      console.log('GET places -----backend.service.ts ----PASO POR: getPlaces');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/lugares', httpOptions);
    }

    getCitizen() {
      console.log('GET citizen -----backend.service.ts ----PASO POR: getCitizen');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/ciudadano/all', httpOptions);
    }

    getCitizenFilterByIntitutions(institutions) {
      console.log('GET citizen -----backend.service.ts ----PASO POR: getCitizen');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }),
        params: new HttpParams().set('entities', institutions)};
      return this._http.get('https://bckend.miape.me/layout/ciudadano/filtered', httpOptions);
    }

    getCiudadanoLastEntries() {
      console.log('GET citizen last entries -----backend.service.ts ----PASO POR: getCiudadanoLastEntries');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/ciudadano/last', httpOptions);
    }

    getCiudadanoAll(number) {
      console.log('GET citizen all of a number -----backend.service.ts ----PASO POR: getCiudadanoAll');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/ciudadano/all/' + number, httpOptions);
    }

    getCiudadanoLast(number) {
      console.log('GET citizen last of a number -----backend.service.ts ----PASO POR: getCiudadanoLast');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/ciudadano/last/' + number, httpOptions);
    }

    getCiudadanoIdentification() {
      console.log('GET citizen last of a number -----backend.service.ts ----PASO POR: getCiudadanoLast');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/ciudadano/identification', httpOptions);
    }

    getCiudadanoById(id) {
      console.log('GET citizen last of a number -----backend.service.ts ----PASO POR: getCiudadanoLast');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/ciudadano/one/' + id, httpOptions);
    }

    getInstitution() {
      console.log('GET institucion -----backend.service.ts ----PASO POR: getInstitucion');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/instituciones', httpOptions);
    }

    getProjects() {
      console.log('GET project -----backend.service.ts ----PASO POR: getProject');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/proyectos', httpOptions);
    }


    getInstitutionsPerProject(id_project) {
      console.log('GET project ' + id_project + ' institutions -----backend.service.ts ----PASO POR: getInstitutionsPerProject');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/proyectos/' + id_project + '/institutions', httpOptions);
    }

    getSmartBand() {
      console.log('GET smartBand -----backend.service.ts ----PASO POR: getSmartBand');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view}) };
      return this._http.get('https://bckend.miape.me/layout/historial/smartBand', httpOptions);
    }

    getScale() {
      console.log('GET scale -----backend.service.ts ----PASO POR: getScale');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view}) };
      return this._http.get('https://bckend.miape.me/layout/historial/scale', httpOptions);
    }

    getSection1() {
      console.log('GET section1 -----backend.service.ts ----PASO POR: getSection1');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/form1', httpOptions);
    }

    getSection2() {
      console.log('GET section2 -----backend.service.ts ----PASO POR: getSection2');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/form2', httpOptions);
    }

    getSection3() {
      console.log('GET section3 -----backend.service.ts ----PASO POR: getSection3');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/form3', httpOptions);
    }

    getSection4() {
      console.log('GET section4 -----backend.service.ts ----PASO POR: getSection4');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/form4', httpOptions);
    }

    getMMSE() {
      console.log('GET minimental -----backend.service.ts ----PASO POR: getMMSE');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/minimental', httpOptions);
    }

    getBDS() {
      console.log('GET blessed -----backend.service.ts ----PASO POR: getBDS');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/blessed', httpOptions);
    }

    getUCLA() {
      console.log('GET ucla -----backend.service.ts ----PASO POR: getUCLA');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/ucla', httpOptions);
    }

    getPANAS() {
      console.log('GET panas -----backend.service.ts ----PASO POR: getPANAS');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/panas', httpOptions);
    }

    getWHOQOL() {
      console.log('GET whoqol -----backend.service.ts ----PASO POR: getWHOQOL');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/whoqol', httpOptions);
    }

    getGDS() {
      console.log('GET gds -----backend.service.ts ----PASO POR: getGDS');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/gds', httpOptions);
    }

    getESCALASOCIAL() {
      console.log('GET escalasocial -----backend.service.ts ----PASO POR: getESCALASOCIAL');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/escalasocial', httpOptions);
    }


    getEARVI() {
      console.log('GET earvi -----backend.service.ts ----PASO POR: getEARVI');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/earvi', httpOptions);
    }

    getESC() {
      console.log('GET esc -----backend.service.ts ----PASO POR: getESC');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/esc', httpOptions);
    }

    getNACI() {
      console.log('GET naci -----backend.service.ts ----PASO POR: getNACI');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/naci', httpOptions);
    }

    getPNACI() {
      console.log('GET pnaci -----backend.service.ts ----PASO POR: getPNACI');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/pnaci', httpOptions);
    }

    // ----------- GET FORMS BY ID PACIENTE FOR EXPORT ---------- //

    getENCSByIdPaciente(id_paciente) {
      // console.log("GET encs -----backend.service.ts ----PASO POR: getENCSByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/encs/' + id_paciente, httpOptions);
    }

    getBDSByIdPaciente(id_paciente) {
      // console.log("GET bds -----backend.service.ts ----PASO POR: getBDSByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/blessed/' + id_paciente, httpOptions);
    }

    getMMSEByIdPaciente(id_paciente) {
      // console.log("GET mmse -----backend.service.ts ----PASO POR: getMMSEByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/minimental/' + id_paciente, httpOptions);
    }

    getEARVIByIdPaciente(id_paciente) {
      // console.log("GET earvi -----backend.service.ts ----PASO POR: getEARVIByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/earvi/' + id_paciente, httpOptions);
    }

    getUCLAByIdPaciente(id_paciente) {
      // console.log("GET ucla -----backend.service.ts ----PASO POR: getUCLAByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/ucla/' + id_paciente, httpOptions);
    }

    getPANASByIdPaciente(id_paciente) {
      // console.log("GET panas -----backend.service.ts ----PASO POR: getPANASByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/panas/' + id_paciente, httpOptions);
    }

    getWHOQOLByIdPaciente(id_paciente) {
      // console.log("GET whoqol -----backend.service.ts ----PASO POR: getWHOQOLByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/whoqol/' + id_paciente, httpOptions);
    }

    getGDSByIdPaciente(id_paciente) {
      // console.log("GET gds -----backend.service.ts ----PASO POR: getGDSByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/gds/' + id_paciente, httpOptions);
    }

    getESCALASOCIALByIdPaciente(id_paciente) {
      // console.log("GET escalasocial -----backend.service.ts ----PASO POR: getESCALASOCIALByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/escalasocial/' + id_paciente, httpOptions);
    }

    getESCByIdPaciente(id_paciente) {
      // console.log("GET esc -----backend.service.ts ----PASO POR: getESCByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/esc/' + id_paciente, httpOptions);
    }

    getNACIByIdPaciente(id_paciente) {
      // console.log("GET naci -----backend.service.ts ----PASO POR: getNACIByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/naci/' + id_paciente, httpOptions);
    }

    getPNACIByIdPaciente(id_paciente) {
      // console.log("GET pnaci -----backend.service.ts ----PASO POR: getPNACIByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/pnaci/' + id_paciente, httpOptions);
    }



    // ----------- GET FORMS BY ID PACIENTE LIST FOR EXPORT ---------- //
    getENCSByIdPacienteList(ids) {
      // console.log("GET encs -----backend.service.ts ----PASO POR: getENCSByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'ids': ids};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/encs/ids', data, httpOptions);
    }

    getBDSByIdPacienteList(ids) {
      // console.log("GET bds -----backend.service.ts ----PASO POR: getBDSByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'ids': ids};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/blessed/ids', data, httpOptions);
    }

    getMMSEByIdPacienteList(ids) {
      // console.log("GET mmse -----backend.service.ts ----PASO POR: getMMSEByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'ids': ids};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/minimental/ids', data, httpOptions);
    }

    getEARVIByIdPacienteList(ids) {
      // console.log("GET earvi -----backend.service.ts ----PASO POR: getEARVIByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'ids': ids};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/earvi/ids', data, httpOptions);
    }

    getUCLAByIdPacienteList(ids) {
      // console.log("GET ucla -----backend.service.ts ----PASO POR: getUCLAByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'ids': ids};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/ucla/ids', data, httpOptions);
    }

    getPANASByIdPacienteList(ids) {
      // console.log("GET panas -----backend.service.ts ----PASO POR: getPANASByIdPacienteList");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'ids': ids};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/panas/ids', data, httpOptions);
    }

    getWHOQOLByIdPacienteList(ids) {
      // console.log("GET whoqol -----backend.service.ts ----PASO POR: getWHOQOLByIdPacienteList");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'ids': ids};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/whoqol/ids', data, httpOptions);
    }

    getGDSByIdPacienteList(ids) {
      // console.log("GET gds -----backend.service.ts ----PASO POR: getGDSByIdPacienteList");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'ids': ids};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/gds/ids', data, httpOptions);
    }

    getESCALASOCIALByIdPacienteList(ids) {
      // console.log("GET escalasocial -----backend.service.ts ----PASO POR: getESCALASOCIALByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'ids': ids};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/escalasocial/ids', data, httpOptions);
    }

    getESCByIdPacienteList(ids) {
      // console.log("GET esc -----backend.service.ts ----PASO POR: getESCByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'ids': ids};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/esc/ids', data, httpOptions);
    }

    getNACIByIdPacienteList(ids) {
      // console.log("GET naci -----backend.service.ts ----PASO POR: getNACIByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'ids': ids};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/naci/ids', data, httpOptions);
    }


    getPNACIByIdPacienteList(ids) {
      // console.log("GET pnaci -----backend.service.ts ----PASO POR: getPNACIByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'ids': ids};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/layout/pnaci/ids', data, httpOptions);
    }

    // --------------------------- GET FOR AUTOCOMPLETE ---------------------------------- //

    getCiudadanoLastAutocomplete(number) {
      console.log('GET citizen last of a number -----backend.service.ts ----PASO POR: getCiudadanoLast');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/ciudadano/last/' + number + '?autocomplete=True', httpOptions);
    }

    getCiudadanoLastEntriesAutocomplete() {
      console.log('GET citizen last entries -----backend.service.ts ----PASO POR: getCiudadanoLastEntries');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/ciudadano/last?autocomplete=True', httpOptions);
    }

    getLastENCSAutocomplete(number) {
      console.log('GET last encs -----backend.service.ts ----PASO POR: getLastENCSAutocomplete');
      console.log('https://bckend.miape.me/layout/encs/last/' + number);
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/encs/last/' + number, httpOptions);
    }

    getLastMMSEAutocomplete(number) {
      console.log('GET last mmse -----backend.service.ts ----PASO POR: getLastMMSEAutocomplete');
      console.log('https://bckend.miape.me/layout/mmse/last/' + number);
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/mmse/last/' + number, httpOptions);
    }

    getLastBDSAutocomplete(number) {
      console.log('GET last bds -----backend.service.ts ----PASO POR: getLastBDSAutocomplete');
      console.log('https://bckend.miape.me/layout/blessed/last/' + number);
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/blessed/last/' + number, httpOptions);
    }

    getLastEARVIAutocomplete(number) {
      console.log('GET last earvi -----backend.service.ts ----PASO POR: getLastEARVIAutocomplete');
      console.log('https://bckend.miape.me/layout/earvi/last/' + number);
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/earvi/last/' + number, httpOptions);
    }

    getLastUCLAAutocomplete(number) {
      console.log('GET last ucla -----backend.service.ts ----PASO POR: getLastUCLAAutocomplete');
      console.log('https://bckend.miape.me/layout/ucla/last/' + number);
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/ucla/last/' + number, httpOptions);
    }

    getLastESCAutocomplete(number) {
      console.log('GET last esc -----backend.service.ts ----PASO POR: getLastESCAutocomplete');
      console.log('https://bckend.miape.me/layout/esc/last/' + number);
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/esc/last/' + number, httpOptions);
    }

    getLastNACIAutocomplete(number) {
      console.log('GET last naci -----backend.service.ts ----PASO POR: getLastNACIAutocomplete');
      console.log('https://bckend.miape.me/layout/naci/last/' + number);
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/naci/last/' + number, httpOptions);
    }

    getLastPNACIAutocomplete(number) {
      console.log('GET last pnaci -----backend.service.ts ----PASO POR: getLastPNACIAutocomplete');
      console.log('https://bckend.miape.me/layout/pnaci/last/' + number);
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/pnaci/last/' + number, httpOptions);
    }

    getLastESCALASOCIALAutocomplete(number) {
      console.log('GET last escala social -----backend.service.ts ----PASO POR: getLastESCALASOCIALAutocomplete');
      console.log('https://bckend.miape.me/layout/escalasocial/last/' + number);
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/escalasocial/last/' + number, httpOptions);
    }

    getLastGDSAutocomplete(number) {
      console.log('GET last gds -----backend.service.ts ----PASO POR: getLastGDSAutocomplete');
      console.log('https://bckend.miape.me/layout/gds/last/' + number);
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/gds/last/' + number, httpOptions);
    }

    getLastWHOQOLAutocomplete(number) {
      console.log('GET last whoqol -----backend.service.ts ----PASO POR: getLastWHOQOLAutocomplete');
      console.log('https://bckend.miape.me/layout/whoqol/last/' + number);
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/whoqol/last/' + number, httpOptions);
    }

    getLastPANASAutocomplete(number) {
      console.log('GET last panas -----backend.service.ts ----PASO POR: getLastPANASAutocomplete');
      console.log('https://bckend.miape.me/layout/panas/last/' + number);
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/panas/last/' + number, httpOptions);
    }

    getStats(institution, place, time_init, time_end) {
      // console.log("GET naci -----backend.service.ts ----PASO POR: getNACIByIdPaciente");
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const data = { 'institution': institution,
                    'place': place,
                    'time_init': time_init,
                    'time_end': time_end};
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.get('https://bckend.miape.me/layout/stats?institution=' + institution + '&place=' + place + '&timeinit=' + time_init + '&timeend=' + time_end, httpOptions);
    }

    // --------------------------- UPDATE ---------------------------------- //
    updateInstitution(formData) {
      console.log('UPDATE institution -----backend.service.ts ----PASO POR: updateInstitution');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.put('https://bckend.miape.me/layout/instituciones', formData, httpOptions);
    }

    updateProject(formData) {
      console.log('UPDATE project -----backend.service.ts ----PASO POR: updateProject');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.put('https://bckend.miape.me/layout/proyectos', formData, httpOptions);
    }

    updateUser(formData) {
      console.log('UPDATE user -----backend.service.ts ----PASO POR: updateUser');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.put('https://bckend.miape.me/layout/blank-page', formData, httpOptions);
    }

    updatePlaces(formData) {
      console.log('UPDATE places -----backend.service.ts ----PASO POR: updatePlaces');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.put('https://bckend.miape.me/layout/lugares', formData, httpOptions);
    }

    updateConfig(formData) {
      console.log('PUT config -----backend.service.ts ----PASO POR: updateConfig');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.put('https://bckend.miape.me/configuration', formData, httpOptions);
    }

    setRoles(formData) {
      console.log('PUT roles -----backend.service.ts ----PASO POR: setRoles');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.put('https://bckend.miape.me/configuration/roles', formData, httpOptions);
    }


    updateCiudadanoIdentification(id, number, code) {
        console.log('PUT roles -----backend.service.ts ----PASO POR: setRoles');
        const formData = {'number': number, 'codigo': code};
        const token = this.getToken();
        const selected_view = this.getSelectedView();
        const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
        return this._http.put('https://bckend.miape.me/layout/ciudadano/identification/' + id, formData, httpOptions);
    }


    // ---------------------------- DELETE ------------------------- //

    /*deleteUser(id) {
      console.log('DELETE user -----backend.service.ts ----PASO POR: deleteUser');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }), body: { id: id }};
      return this._http.delete('https://bckend.miape.me/layout/blank-page/', httpOptions);
    }*/

    deleteRole(id, role) {
      console.log('DELETE role -----backend.service.ts ----PASO POR: deleteRole');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }), body: { id: id }};
      return this._http.delete('https://bckend.miape.me/layout/user/' + id + '?role=' + role, httpOptions);
    }

    deletePlace(id) {
      console.log('DELETE place -----backend.service.ts ----PASO POR: deletePlace');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }), body: { id: id }};
      return this._http.delete('https://bckend.miape.me/layout/lugares/', httpOptions);
    }

    deleteInstitution(id) {
      console.log('DELETE institution -----backend.service.ts ----PASO POR: deleteInsititution');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }), body: { id: id }};
      return this._http.delete('https://bckend.miape.me/layout/instituciones/ ', httpOptions);
    }

    deleteProject(id) {
      console.log('DELETE project -----backend.service.ts ----PASO POR: deleteProject');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }), body: { id: id }};
      return this._http.delete('https://bckend.miape.me/layout/proyectos/ ', httpOptions);
    }

    // ------------------------------- ALERTS ---------------------------- //

    createAlert(formData) {
      console.log('ADD alert -----backend.service.ts ----PASO POR: createAlert');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) };
      return this._http.post('https://bckend.miape.me/alerts', formData, httpOptions);
    }

    // ------------------------------- LOGIN ---------------------------- //

    login(formData) {
      console.log('ADD login -----backend.service.ts ----PASO POR: login');
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json'}) };
      return this._http.post('https://bckend.miape.me/login', formData, httpOptions);
    }

    // ------------------------------- PASSWORD RECOVERY ---------------------------- //

    requestPasswordRecovery(formData) {
      console.log('REQUEST Password Recovery -----backend.service.ts ----PASO POR: requestPasswordRecovery');
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json'}) };
      return this._http.post('https://bckend.miape.me/mail/password-recovery', formData, httpOptions);
    }

    getPasswordRecovery(token) {
      console.log('GET Password Recovery -----backend.service.ts ----PASO POR: getPasswordRecovery');
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json'}) };
      return this._http.get('https://bckend.miape.me/password-recovery/' + token, httpOptions);
    }

    postPasswordRecovery(formData) {
      console.log('POST Password Recovery -----backend.service.ts ----PASO POR: postPasswordRecovery');
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json'}) };
      return this._http.post('https://bckend.miape.me/password-recovery', formData, httpOptions);
    }

    // ---------------------------- BUSCAR ------------------------- //
    findIDCiudadano(id) {
      console.log('ADD findIDCIudadano -----backend.service.ts ----PASO POR: finIDCIudadano');
      const token = this.getToken();
      const selected_view = this.getSelectedView();
      const httpOptions = { headers: new HttpHeaders({ 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE', 'Access-Control-Allow-Headers': 'Content-Type', 'Access-Control-Allow-Origin': 'https://www.miape.me', 'Content-Type': 'application/json', 'Authorization': token, 'View': selected_view }) , body: { number: id }};
      return this._http.get('https://bckend.miape.me/layout/historial/smartBand', httpOptions);
    }


}
